module.exports = __webpack_public_path__ + "img/myjl@2x.94b34880.png";